<template>
    <div class="setup">
        <div class="breadcrumb-content">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/live' }">直播管理</el-breadcrumb-item>
                <el-breadcrumb-item>直播设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="setup-title mg-top16">
            <span>直播设置</span>
            <div class="setup-title-btn" v-if="activeTabs == 'detail'">
                <el-button type="primary" size="small" @click="editDetail">编 辑</el-button>
            </div>
        </div>
        <div class="mg-top8">
            <el-tabs v-model="activeTabs" @tab-click="handleTabs">
                <el-tab-pane label="直播详情" name="detail"></el-tab-pane>
                <el-tab-pane label="直播条件设置" name="condition"></el-tab-pane>
                <el-tab-pane label="直播录制列表" name="list"></el-tab-pane>
                <el-tab-pane label="直播统计" name="statistics"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="setup-container">
            <div class="setup-detail" v-show="activeTabs == 'detail'">
                <SetupDetail v-bind:liveDetail="liveDetail"/>
            </div>
            <div class="setup-condition" v-show="activeTabs == 'condition'">
                <SetupCondition v-bind:liveDetail="liveDetail"/>
            </div>
            <div class="setup-list" v-show="activeTabs == 'list'">
                <SetupList />
            </div>
            <div class="setup-statistics" v-show="activeTabs == 'statistics'">
                <SetupStatistics v-bind:liveDetail="liveDetail"/>
            </div>
        </div>
        <div v-if="liveDialog">
            <el-dialog :title="dialogTitle" :visible.sync="liveDialog" width="580px">
                <div class="liveForm-content">
                    <el-form :model="liveForm" :rules="liveRule" ref="liveForm" label-width="127px" label-position="left">
                        <el-form-item label="直播名称：" prop="title">
                            <el-input v-model="liveForm.title" placeholder="给直播起个名字"></el-input>
                        </el-form-item>
                        <el-form-item label="直播间密码：" prop="password">
                            <el-input v-model="liveForm.password" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="讲师昵称：" prop="lecturer">
                            <el-input v-model="liveForm.lecturer" placeholder="请输入"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="直播场景：" required>
                            <el-radio-group v-model="liveForm.resource">
                                <el-radio label="互动课堂"></el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                        <el-form-item label="开播时间：" prop="begin_time">
                            <el-date-picker
                                v-model="liveForm.begin_time"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                                placeholder="设置直播开始时间" style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="串流密钥有效期：" prop="expire_time" v-if="!liveId">
                            <el-input placeholder="请输入" v-model="liveForm.expire_time">
                                <template slot="append">秒</template>
                            </el-input>
                        </el-form-item> -->
                        <el-form-item label="直播封面：" prop="cover">
                            <SingleUpload v-bind:child-msg="uploadParams" v-on:imageUrl="imageUrl($event)" />
                        </el-form-item>
                        <el-form-item label="直播介绍：" prop="intro">
                            <el-input type="textarea" placeholder="请输入关于直播内容的介绍" v-model="liveForm.intro" rows='7' maxlength="128" show-word-limit></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="liveDialog = false" >取 消</el-button>
                    <el-button type="primary" :loading="loading" size="small" @click="handleLive">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { detailLive, editLive } from '@/api/live/index'
import SingleUpload from '@/components/SingleUpload'
import SetupDetail from './components/setupDetail'
import SetupCondition from './components/setupCondition'
import SetupList from './components/setupList'
import SetupStatistics from './components/setupStatistics'

export default {
    inject: ['reload'],
    name: 'setup',
    data() {
        const validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('密码不能为空'))
            } else {
                const reg = /.*[\u4e00-\u9fa5]+.*$/
                if (reg.test(value)) {
                    return callback(new Error('密码不能包含汉字'))
                } else {
                    callback()
                }
            }
        }
        const expireTime = (rule, value, callback) => {
            if (!value) {
                callback(new Error('串流密钥有效期不能为空'))
            } else {
                const reg = /\D|^0/g
                if (reg.test(value)) {
                    return callback(new Error('串流密钥有效期只能为数字'))
                } else {
                    callback()
                }
            }
        }
        const validateIntro = (rule, value, callback) => {
            if (!value) {
                callback(new Error('直播介绍不能为空'))
            } else {
                if (value.length > 128) {
                    return callback(new Error('直播频道介绍最大长度为128'))
                } else {
                    callback()
                }
            }
        }
        return {
            liveId: '',
            liveDetail: '',
            activeTabs: sessionStorage.getItem('setupActive') || 'detail',
            dialogTitle: '',
            liveDialog: false,
            liveForm: {},
            loading: false,
            liveRule: {
                title: [
                    { required: true, message: '名称不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, validator: validatePass, trigger: 'blur' }
                ],
                lecturer: [
                    { required: true, message: '讲师昵称不能为空', trigger: 'blur' }
                ],
                begin_time: [
                    { required: true, message: '开播时间不能为空', trigger: 'blur' }
                ],
                // expire_time: [
                //     { required: true, validator: expireTime, trigger: 'blur' }
                // ],
                cover: [
                    { required: true, message: '直播封面不能为空', trigger: 'blur' }
                ],
                intro: [
                    { required: true, validator: validateIntro, trigger: 'blur' }
                ]
            },
            pickerOptions: {
                disabledDate(date) {
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
                }
            },
            uploadParams: {
                width: '264',
                height: '148',
                tip: '尺寸：（1560*878px，比例为16:9）',
                imageUrl: ''
            }
        }
    },
    components: {
        SingleUpload,
        SetupDetail,
        SetupCondition,
        SetupList,
        SetupStatistics
    },
    created() {
        this.liveId = this.$route.query.id
        this.detailLive()
    },
    methods: {
        detailLive() {
            detailLive(this.liveId).then(res => {
                if (res.code === 0) {
                    this.liveDetail = res.data
                }
            }).catch(res => {})
        },
        handleTabs(tab) {
            sessionStorage.setItem('setupActive', tab.name)
        },
        editDetail() {
            this.dialogTitle = '编辑直播'
            this.liveForm = this.liveDetail
            this.uploadParams.imageUrl = this.liveDetail.cover
            this.liveDialog = true
        },
        handleLive() {
            this.$refs['liveForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    editLive(this.liveForm, this.liveId).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message.success(res.msg)
                            this.reload()
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        imageUrl(url) {
            this.liveForm.cover = url
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.setup{
    padding-top: 32px;
}
.setup-title{
    position: relative;
    line-height: 32px;
    font-size: 24px;
    color: #333;
    .setup-title-btn{
        position: absolute;
        top: 0;
        right: 0;
        font-size: 0;
    }
}

.liveForm-content{
    .el-form-item:last-child{
        margin-bottom: 0;
    }
}

</style>
